// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"0ba2cf51","755":"55365635","856":"a67f82dd"}[chunkId] + ".chunk.js";
};